import React, { useState, useEffect, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ChatbotAPI from '../../services/chatbot.service';
import useAuth from '../../hooks/auth.hook';
import { useNavigate } from 'react-router-dom';

const chatbotAPI = new ChatbotAPI();

function ChatbotData() {
  const { user } = useAuth();
  const [options, setOptions] = useState<{ id: string; name: string; data: string }[]>([]);
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const editorRefs = useRef<Record<string, any>>({});
  const navigate = useNavigate();

  const fetchOptions = async () => {
    try {
      const response = await chatbotAPI.listUnits();
      console.log(response.data.data);
      setOptions(response.data.data);
      if (response.data.data.length > 0) {
        setActiveTab(response.data.data[0].id);
      }
    } catch (error) {
      console.error('Error al obtener las opciones:', error);
    }
  };

  const saveOption = async (id: string, updatedData: string) => {
    try {
      const response = await chatbotAPI.updateUnits(id, updatedData);
      if (response.status === 200) {
        console.log(`Opción ${id} guardada exitosamente.`);
        alert('✅ Datos guardados correctamente.');
      } else {
        console.error('Error al guardar la opción:', response.statusText);
        alert('❌ Ocurrió un error al guardar. Inténtalo nuevamente.');
      }
    } catch (error) {
      console.error('Error al guardar la opción:', error);
      alert('❌ Error en la conexión. Inténtalo más tarde.');
    }
  };

  useEffect(() => {
    if (user?.role === 'MANAGER') {
      navigate('/../businesses');
    }

    fetchOptions();
  }, []);

  const handleSave = (id: string) => {
    if (editorRefs.current[id]) {
      const updatedData = editorRefs.current[id].getData();
      saveOption(id, updatedData);

      setOptions((prev) =>
        prev.map((option) => (option.id === id ? { ...option, data: updatedData } : option))
      );
    }
  };

  return (
    <div>
      <h5>Unidades</h5>
      {/* Contenedor de Tabs */}
      <div style={{ display: 'flex', borderBottom: '2px solid #ccc', marginBottom: '20px' }}>
        {options.map((option) => (
          <button
            key={option.id}
            style={{
              flex: 1,
              padding: '10px',
              border: 'none',
              backgroundColor: activeTab === option.id ? '#89c2ff' : '#f8f9fa',
              color: activeTab === option.id ? '#fff' : '#000',
              cursor: 'pointer'
            }}
            onClick={() => setActiveTab(option.id)}>
            {option.name}
          </button>
        ))}
      </div>

      {/* Contenido del Tab activo */}
      {options.map((option) =>
        activeTab === option.id ? (
          <div key={option.id}>
            <div style={{ marginBottom: '1rem' }}>
              <button
                style={{
                  margin: 'auto',
                  padding: '5px 10px',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  width: '30%',
                  display: 'block'
                }}
                onClick={() => handleSave(option.id)}>
                Guardar
              </button>
            </div>
            <CKEditor
              editor={ClassicEditor}
              config={{
                licenseKey: 'GPL',
                toolbar: ['undo', 'redo', '|', 'bold', 'italic', '|', 'paragraph']
              }}
              data={option.data}
              onReady={(editor) => {
                editorRefs.current[option.id] = editor;
              }}
            />
          </div>
        ) : null
      )}
    </div>
  );
}

export default ChatbotData;
